/**
 * Renders the Sold Home Card (NHS20-8826) — pure function. Styled per the Figma "Sold Card /
 * Master" component (mobile bottom sheet + desktop dynamic panel share the same markup; only the
 * enclosing sold-card-group's width differs, handled by the grid classes in
 * services/listViewContentService.js). Not clickable per the ticket ("Sold cards must not be
 * clickable"), so unlike this feature's other card renderers it carries no
 * data-lot-id/data-plan-id click hook.
 *
 * @module nativeInteractiveSiteMap/components/soldHomeCard.dom
 */

/**
 * @param {object} soldHome - One redux/selectors.js#selectSoldHomes entry.
 * @returns {string} HTML string.
 */
export default function renderSoldHomeCard(soldHome) {
  const specs = [
    soldHome.bedrooms != null ? { value: soldHome.bedrooms, unit: 'Bd' } : null,
    soldHome.formattedBathrooms != null ? { value: soldHome.formattedBathrooms, unit: 'Ba' } : null,
    soldHome.garage != null ? { value: Math.round(soldHome.garage), unit: 'Gr' } : null,
    soldHome.formattedSquareFeet != null ? { value: soldHome.formattedSquareFeet, unit: 'SqFt' } : null,
  ].filter(Boolean);

  const specsHtml = specs
    .map(
      ({ value, unit }) =>
        `<span class="nhs-c-native-interactive-site-map__spec" data-qa="native_ism_sold_home_card_spec">` +
        `<span class="nhs-c-native-interactive-site-map__spec-value nhs-mq-native-interactive-site-map__spec-value-medium">${value}</span> ` +
        `<span class="nhs-c-native-interactive-site-map__spec-unit nhs-mq-native-interactive-site-map__spec-unit-medium">${unit}</span>` +
        `</span>`
    )
    .join('');

  return `
    <article class="nhs-c-native-interactive-site-map__sold-card" data-qa="native_ism_sold_home_card">
      <h4 class="nhs-c-native-interactive-site-map__sold-card-badge">Sold</h4>
      <p class="nhs-c-native-interactive-site-map__sold-card-address nhs-mq-native-interactive-site-map__sold-card-address-medium" data-qa="native_ism_sold_home_card_address">${soldHome.address ?? ''}</p>
      <div class="nhs-c-native-interactive-site-map__spec-list" data-qa="native_ism_sold_home_card_specs">${specsHtml}</div>
    </article>
  `;
}
